import React from 'react';
import { InstantSearch, Configure } from 'react-instantsearch-dom';

import { ReviewsResults } from '../../commons/helpers';

const SearchReviewsContent = ({
  indexName,
  searchClient,
  searchState,
  searchStateQuery,
  updateSearchPage,
}) => (
  <div className="w-full">
    <InstantSearch
      searchClient={searchClient}
      searchState={searchState}
      indexName={indexName}
    >
      <Configure
        query={searchStateQuery}
        hitsPerPage={9}
        facetFilters={searchState.configure.facetFilters}
      />

      <ReviewsResults onLoadMore={updateSearchPage} variant="advanced-search" />
    </InstantSearch>
  </div>
);

export default SearchReviewsContent;
